import { motion } from "framer-motion";
import { Mail, MessageCircle, ExternalLink, Heart } from "lucide-react";
import logoTander from "../../assets/WhatsApp_Image_2025-08-29_at_16.10.10-removebg-preview.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    produto: [
      { name: "Potencial IA", href: "#funcionalidades" },
      { name: "Acesso Inteligente", href: "#planos" },
      { name: "API", href: "#" },
      { name: "Documentação", href: "#" },
    ],
    empresa: [
      { name: "Sobre nós", href: "#" },
      { name: "Blog", href: "#" },
      { name: "Carreiras", href: "#" },
      { name: "Imprensa", href: "#" },
    ],
    suporte: [
      { name: "Central de Ajuda", href: "#" },
      { name: "Contato", href: "#contato" },
      { name: "Status", href: "#" },
      { name: "Comunidade", href: "#" },
    ],
    legal: [
      { name: "Termos de Uso", href: "#" },
      { name: "Privacidade", href: "#" },
      { name: "Cookies", href: "#" },
      { name: "Licenças", href: "#" },
    ],
  };

  const socialLinks = [
    { name: "LinkedIn", href: "#", icon: "💼" },
    { name: "Twitter", href: "#", icon: "🐦" },
    { name: "GitHub", href: "#", icon: "💻" },
  ];

  return (
    <footer id="contato" className="bg-gray-900 text-white">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="py-8 border-t border-gray-1000"
      >
        {/* <div className="text-center">
          <h3 className="text-xl font-semibold mb-4">
            Fique por dentro das novidades
          </h3>
        </div> */}
        <div className="text-center max-w-md mx-auto">
        {/* <div className="flex items-center space-x-2 mb-4"> */}
          <img src={logoTander} alt="TANDER SMART" className="w-80 h-50" />
        {/* </div> */}
        </div>
        <div className="text-center">
          <p>
            <h3 className="text-xl font-semibold mb-4">
              VOCÊ PENSA. TANDER SMART APRENDE E EVOLUI POR VOCÊ!
            </h3>
            
          </p>
        </div>
        
        {/* <div className="text-center">
            <h3 className="text-xl font-semibold mb-4">
              Fique por dentro das novidades
            </h3>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
              Receba atualizações sobre novas funcionalidades, dicas de uso e 
              casos de sucesso do TANDER.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
              <input
                type="email"
                placeholder="Seu melhor email"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
              <button className="btn-primary whitespace-nowrap">
                Inscrever-se
              </button>
            </div>
          </div> */}
      </motion.div>

      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
            {/* Brand Section */}
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="mb-6"
              >
                {/* <div className="flex items-center space-x-2 mb-4">
                  <img 
                    src={logoTander} 
                    alt="TANDER SMART" 
                    className="w-80 h-50"
                  />
                  {/* <span className="text-2xl font-bold">TANDER SMART</span> */}
                {/* <p className="text-gray-200 leading-relaxed mb-8">
                  Análise inteligente de documentos com IA.
                  <p>Transforme informações em decisões de forma rápida, simples e eficaz.</p>

                </p> }

                
                </div> */}

                {/* Contact Info */}
                <div className="space-y-3">
                  <div className="flex items-center space-x-3 text-gray-300">
                    <Mail className="w-5 h-5 text-primary-400" />
                    <span>tandersmart@tandersolucoes.com.br</span>
                  </div>
                  <div className="flex items-center space-x-3 text-gray-300">
                    <MessageCircle className="w-5 h-5 text-accent-400" />
                    <span>+55 (16) 99710-1196</span>
                  </div>
                </div>
              </motion.div>
            </div>
            <div></div>

            {/* Links Sections */}
            {Object.entries(footerLinks).map(([section, links]) => (
              <div key={section}>
                <motion.h3
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                  className="text-lg font-semibold mb-4 capitalize"
                >
                  {section}
                </motion.h3>
                <motion.ul
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="space-y-2"
                >
                  {links.map((link, index) => (
                    <li key={index}>
                      <a
                        href={link.href}
                        className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center space-x-1 group"
                      >
                        <span>{link.name}</span>
                        {link.href.startsWith("http") && (
                          <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                        )}
                      </a>
                    </li>
                  ))}
                </motion.ul>
              </div>
            ))}
          </div>
        </div>

        {/* Newsletter Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="py-8 border-t border-gray-1000"
        >
          <div className="text-center">
            <h3 className="text-xl font-semibold mb-4">
              Fique por dentro das novidades
            </h3>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
              Receba atualizações sobre novas funcionalidades, dicas de uso e
              casos de sucesso do TANDER.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
              <input
                type="email"
                placeholder="Seu melhor email"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
              <button className="btn-primary whitespace-nowrap">
                Inscrever-se
              </button>
            </div>
          </div>
        </motion.div>

        {/* Bottom Footer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="py-8 border-t border-gray-800"
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              © {currentYear} TANDER SMART. Todos os direitos reservados. Feito com{" "}
              <Heart className="inline w-4 h-4 text-red-500" /> no Brasil.
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-6">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-lg"
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </motion.div>
      </div>

      {/* WhatsApp Float Button */}
      <motion.a
        href="https://wa.me/5516997101196?text=Olá! Quero saber mais sobre TANDER SMART"
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 z-50"
      >
        <MessageCircle className="w-8 h-8 text-white" />
      </motion.a>
    </footer>
  );
};

export default Footer;
